import { createSelector } from 'reselect';

export const selectChecklistFromState = (state) => state.checklist;

export const selectChecklist = (state) => state.checklist;

export const selectIsChecklistValid = (checklist) => checklist && checklist.isChecklistValid;

export const selectShouldOpenDialog = (checklist) => checklist && checklist.shouldOpenDialog;

export const selectFinishSessionError = (checklist) => checklist &&
  checklist.finishSessionError;

export const makeSelectIsChecklistValid = () => createSelector(
  selectChecklistFromState,
  selectIsChecklistValid,
);

export const makeSelectShouldOpenDialog = () => createSelector(
  selectChecklistFromState,
  selectShouldOpenDialog,
);

export const selectProgress = (checklists) => checklists && checklists.progress;

export const makeSelectProgress = () => createSelector(
  selectChecklistFromState,
  selectProgress,
);

export const selectHasFetchedGeneralConditionsItems = (checklist) =>
  checklist && checklist.hasFetchedGeneralConditionsItems;

export const makeSelectHasFetchedGeneralConditionsItems = () => createSelector(
  selectChecklistFromState,
  selectHasFetchedGeneralConditionsItems,
);

export const makeSelectFinishSessionError = () => createSelector(
  selectChecklistFromState,
  selectFinishSessionError,
);
